<template>
    <div>
      <trademark-opposition-list></trademark-opposition-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  
  